
    import '/opt/buildhome/repo/components/thought-chain/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["thought-chain-demo-basic","thought-chain-demo-size","thought-chain-demo-status","thought-chain-demo-collapsible","thought-chain-demo-customization","thought-chain-demo-nested","thought-chain-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/thought-chain/index.en-US.md?type=demo')
};